import { useGoogleLogin } from "@react-oauth/google";
import { G } from "../constants.js";

const SCOPES = [
  "https://www.googleapis.com/auth/drive.file",
  "https://www.googleapis.com/auth/userinfo.email",
  "https://www.googleapis.com/auth/userinfo.profile",
].join(" ");

export default function GoogleAuth({ onToken }) {
  const login = useGoogleLogin({
    scope: SCOPES,
    onSuccess: res => onToken(res.access_token, res.expires_in),
    onError:   err => console.error("Login failed:", err),
  });

  return (
    <div style={{ minHeight:"100vh", background:"#070710", backgroundImage:"radial-gradient(ellipse 60% 60% at 50% 50%, rgba(255,255,255,.04) 0%, #070710 70%)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", fontFamily:"'DM Sans',sans-serif" }}>
      <style>{G}</style>

      <div style={{ width:"160px", height:"160px", borderRadius:"50%", border:"1px solid rgba(255,255,255,.08)", animation:"orb-breathe 3s ease-in-out infinite", display:"flex", alignItems:"center", justifyContent:"center", marginBottom:"40px", background:"radial-gradient(circle at 40% 35%, rgba(255,255,255,.07) 0%, rgba(255,255,255,.01) 60%, transparent 100%)" }}>
      </div>

      <p style={{ fontFamily:"'Bebas Neue'", fontSize:"36px", letterSpacing:".25em", color:"#E8FF47", marginBottom:"6px" }}>ORACLE</p>
      <p style={{ fontFamily:"'DM Mono'", fontSize:"10px", letterSpacing:".24em", color:"rgba(255,255,255,.18)", textTransform:"uppercase", marginBottom:"52px" }}>your visual library</p>

      <button
        onClick={() => login()}
        style={{ display:"flex", alignItems:"center", gap:"12px", padding:"14px 28px", borderRadius:"10px", background:"rgba(255,255,255,.05)", border:"1px solid rgba(255,255,255,.12)", color:"#fff", cursor:"pointer", fontFamily:"'DM Sans'", fontSize:"14px", fontWeight:"500" }}
        onMouseEnter={e => { e.currentTarget.style.background="rgba(255,255,255,.09)"; e.currentTarget.style.borderColor="rgba(255,255,255,.22)"; }}
        onMouseLeave={e => { e.currentTarget.style.background="rgba(255,255,255,.05)"; e.currentTarget.style.borderColor="rgba(255,255,255,.12)"; }}
      >
        <GoogleIcon />
        Sign in with Google
      </button>

      <p style={{ marginTop:"28px", fontFamily:"'DM Mono'", fontSize:"9px", color:"rgba(255,255,255,.14)", letterSpacing:".1em", textAlign:"center", lineHeight:"1.8", maxWidth:"340px" }}>
        Your library is stored in your own Google Drive.<br />
        ORACLE only accesses files it creates.
      </p>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" fill="#4285F4"/>
      <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
      <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05"/>
      <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
    </svg>
  );
}
